import { render, staticRenderFns } from "./category_id.vue?vue&type=template&id=325d77ca&scoped=true&"
import script from "./category_id.vue?vue&type=script&lang=js&"
export * from "./category_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d77ca",
  null
  
)

export default component.exports